module.exports = __webpack_public_path__ + "img/full5-min.b4bf5e0a.png";